import script from "./PaymentIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentIcon.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__